import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p21_e1.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    hideBtnFooter: true,
    exerciseKey: "/img/FriendsPlus/Page21/key/E1AnswerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    textareaStyle: {
      // background: 'none',
      width: 450,
      fontSize: 22,
      paddingTop: 5,
    },
    titleQuestion: [
      {
        num: "",
        title: `<b style='color:rgb(151 30 17); '>1.</b>&ensp;
     Tìm các câu văn thể hiện thái độ của Giét-xi đối với mỗi vai diễn được giao.</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `

    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>

    //     `,
    //   },
    // ],

    dragAndDrop: [
      {
        decreaseLeft: 200,
        decreaseTop: 70,
        defaultPostion: [
          {
            left: 79,
            top: 55,
          },
          {
            left: -1,
            top: 104,
          },
          {
            left: 76,
            top: 140,
          },
          {
            left: 37,
            top: 307,
          },
          {
            left: 551,
            top: 307,
          },
        ],
        answers: [
          {
            left: 23,
            top: 480,
          },
          {
            left: 1,
            top: 518,
          },
          {
            left: 24,
            top: 555,
          },
          {
            left: 713,
            top: 479,
          },
          {
            left: 714,
            top: 518,
          },
        ],
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em đọc kĩ 2 đoạn đầu của bài đọc, dùng chuột để kéo - thả các câu văn thể hiện thái độ của Giét-xi đối với mỗi vai diễn được giao vào ô phù hợp trong bảng.</span>
        <p style='font-weight:bold'>Các câu khi em đưa chuột vào có hình bàn tay là có thể kéo thả.</p>
        <div><video src="Audios/fpt_ai/guide/p21_e1.mp3" controls style="width: 100%; height: 2cm"></video>
            
        `,
      },
    ],
    questions: [
      {
        title: `
        <div style='width:25cm;margin-top:20px;margin-bottom:20px;font-size:22px'>
          &emsp;Sau bữa ăn trưa, cô giáo thông báo Giét-xi được chọn đóng vai công chúa trong vở kịch sắp tới.
          <span id='drag' style='position:absolute; left:79px; top:55px'>
            Cảm nhận được ánh mắt ngưỡng mộ của bạn bè, Giét-xi vui lắm.
          </span><br/>
          <p></p>
          
          <span id='drag' style='position:absolute; left:-1px; top:104px'>&emsp;Về nhà, Giét-xi hào hứng kể cho mẹ nghe.</span>
          
          <span style='margin-left:460px'>
          Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi.  
          </span> 

          <span id='drag' style='position:absolute; left:76px; top:140px'>Giét-xi  chăm chỉ 
          luyện tập và nhớ lời thoại rất nhanh.</span>


         <span style='margin-left:540px'> Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết. Cuối cùng, cô giáo đành nói:</span>

          <br>
         <p></p>


          &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch. Cô nghĩ vai đó hợp với em hơn. Em có đồng ý đổi vai không?
          <br>
         <p></p>

         <span id ='drag' style='position:absolute; left:37px; top:307px'>Lời nói cô rất dịu dàng nhưng Giét-xi thấy buồn lắm.</span>
         <span  id ='drag' style='position:absolute; left:575px; top:307px'>Sao không buồn khi phải nhường vai chính cho bạn!</span>
         
        
        </div>
        <div style='margin-top:80px'>
        <table style="border-collapse: collapse; width: 100%; width: 1140px">

        <tr style="">
          <td style="border: 1px solid black; padding: 10px; text-align: center; background-color: rgb(104,223,245)"><b>Các câu văn thể hiện thái độ
          của Giét-xi đối với vai diễn công chúa</b></td>
          <td style="border: 1px solid black; padding: 10px; text-align: center; background-color: rgb(104,223,245)"><b>Các câu văn thể hiện thái độ
          của Giét-xi đối với vai diễn người dẫn chuyện</b></td>
        </tr>
        <tr style='border:1px solid black'>
         <td style='border-right:1px solid black;padding-left:10px;padding-top:10px;width:50%'>
         <div >
        
         -....................................................................................................<br/>
         -....................................................................................................<br/>
         -....................................................................................................

         </div>
         </td>
         <td style ='padding-left:10px;padding-top:10px;width:50%'>
         <div >
         -....................................................................................................<br/>
         -....................................................................................................<br/>
         -....................................................................................................

         </div>
         </td>
        </tr>
       

  </table>
        </div>
        
        `,
        answer: ["", ""],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p21_e2.mp3",
    autoPlay: true,
    video: "",
    isTuLuan: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page21/Key/E2answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    textareaStyle: {
      // background: 'none',
      width: 900,
      fontSize: 23,
      // height: 70,
      paddingTop: 5,
    },

    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src=""  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>CÔNG CHÚA VÀ NGƯỜI DẪN CHUYỆN</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `

    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>

    //     `,
    //   },
    // ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em đọc kĩ đoạn 2 của bài đọc để tìm đáp án đúng, sau đó gõ chữ vào các dòng trống.</span>
        <div><video src="Audios/fpt_ai/guide/p21_e2.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questions: [
      {
        title: `
        <img src='/img/FriendsPlus/Page20/E1/3.jpg' style='height:140mm;width:25cm' />
        <div style='width:25cm'>
        &emsp;Sau bữa ăn trưa, cô giáo thông báo Giét-xi được chọn đóng vai công chúa trong vở kịch sắp tới. Cảm nhận được
        ánh mắt ngưỡng mộ của bạn bè, Giét-xi vui lắm.<br>
        &emsp;Về nhà, Giét-xi hào hứng kể cho mẹ nghe. Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi. Giét-xi  chăm chỉ 
        luyện tập và nhớ lời thoại rất nhanh. Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết. 
        Cuối cùng, cô giáo đành nói:<br>
        &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch. Cô nghĩ vai đó hợp với em hơn. Em có đồng ý đổi vai không? <br>
        &emsp;Lời cô rất dịu dàng nhưng Giét-xi thấy buồn lắm. Sao không buồn khi phải nhường vai chính cho bạn!<br>
        &emsp;Thấy Giét-xi buồn, mẹ thủ thỉ:<br>
        &emsp;- Hôm nay mẹ con mình cùng nhau nhổ cỏ vườn nhé.<br>
        &emsp;Khu vườn vào xuân, những cây hồng leo khóac tấm áo xanh mới.<br>
        &emsp;- Mẹ con mình sẽ nhổ hết cỏ và hoa dại ở đây. Từ giờ vườn nhà ta chỉ có hoa hồng thôi. - Vừa nói, mẹ vừa chạm tay vào khóm bồ công anh.<br>
        &emsp;- Đừng, mẹ! Con thích hoa bồ công anh. Loài hoa nào cũng đẹp cả, kể cả bồ công anh. - Giét-xi nói.<br>
        &emsp;Mẹ mỉm cười:<br>
        &emsp;- Đúng rồi, mỗi loài hoa đều có một vẻ đẹp riêng con ạ. Con người cũng vậy, không phải ai cũng thành công chúa, nhưng điều đó không có gì đáng xấu hổ.<br>
        &emsp;Giét-xi đoán mẹ đã biết chuyện thay vai diễn của mình.<br>
        &emsp;Mẹ dịu dàng nói.<br>
        &emsp;- Con gái bé nhỏ của mẹ, con có giọng đọc truyền cảm, rất hợp với vai người dẫn chuyện. Nếu thiếu người dẫn chuyện, vở kịch cũng khó mà thành công được con ạ.<br>

				<div style='text-align: end'>(Du-nan biên soạn, Hoà Vân dịch)</div>
        </div>

        <div style='margin-top: 30px;'>
        <b style='color:rgb(151 30 17); '>2.</b>
        &ensp; Vì sao Giét-xi buồn khi phải đổi sang vai người dẫn chuyện?<br>
        <textarea id='0' rows='5'></textarea>
        </div>
        
        `,
        answer: [
          "",
          //"Đáp án tham khảo: Giét-xi buồn vì nghĩ rằng vai công chúa mới là vai chính, vai quan trọng; được đóng vai công chúa các bạn mới ngưỡng mộ vì công chúa rất xinh đẹp, còn vai người dẫn chuyện là vai phụ, không quan trọng,…",
        ],
      },
    ],
  },

  3: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P24-E1",
    audio: "Audios/fpt_ai/p21_e3.mp3",
    autoPlay: true,
    video: "",
    component: Circle_Write,
    exerciseKey: "img/FriendsPlus/Page21/Key/E3answerKey.png",
    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src=""  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>CÔNG CHÚA VÀ NGƯỜI DẪN CHUYỆN</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `

    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>

    //     `,
    //   },
    // ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em đọc kĩ đoạn trò chuyện giữa Giét-xi và mẹ, suy nghĩ và trả lời câu hỏi. Em kích chuột vào chữ cái trước 1 đáp án đúng.</span>
        <div><video src="Audios/fpt_ai/guide/p21_e3.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 5,
          border: "2px solid white",
          // borderColor: "transparent",
          fontWeight: 700,
          color: "rgb(88,147,198)",
        },
        // initialWordStyle: { fontWeight: 'bold', border: 'none', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: {
          padding: 5,
          border: "2px solid black",
          borderRadius: "50%",
          // borderColor: "",
        },
        limitSelect: 1,
        listWordsStyle: {},
        listWords: ["A <br>| B <br>| C <br>| D"],
        answers: ["0-12"],
        initialValue: [],
      },
      Layout: `
      <img src='/img/FriendsPlus/Page20/E1/3.jpg' style='height:140mm;width:25cm' />
        <div style='width:25cm'>
        &emsp;Sau bữa ăn trưa, cô giáo thông báo Giét-xi được chọn đóng vai công chúa trong vở kịch sắp tới. Cảm nhận được
        ánh mắt ngưỡng mộ của bạn bè, Giét-xi vui lắm.<br>
        &emsp;Về nhà, Giét-xi hào hứng kể cho mẹ nghe. Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi. Giét-xi  chăm chỉ 
        luyện tập và nhớ lời thoại rất nhanh. Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết. 
        Cuối cùng, cô giáo đành nói:<br>
        &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch. Cô nghĩ vai đó hợp với em hơn. Em có đồng ý đổi vai không? <br>
        &emsp;Lời nói cô rất dịu dàng nhưng Giét-xi thấy buồn lắm. Sao không buồn khi phải nhường vai chính cho bạn!<br>
        &emsp;Thấy Giét-xi buồn, mẹ thủ thỉ:<br>
        &emsp;- Hôm nay mẹ con mình cùng nhau nhổ vườn cỏ nhé.<br>
        &emsp;Khu vườn vào xuân, những cây hồng leo khóa tấm áo xanh mới.<br>
        &emsp;- Mẹ con mình sẽ nhổ hết cỏ và hoa dại ở đây. Từ giờ vườn nhà ta chỉ có hoa hồng thôi. - Vừa nói, mẹ vừa chạm tay vào khóm bồ công anh.<br>
        &emsp;- Đừng, mẹ! Con thích hoa bồ công anh. Loài hoa nào cũng đẹp cả, kể cả bồ công anh. - Giét-xi nói.<br>
        &emsp;Mẹ mỉm cười:<br>
        &emsp;- Đúng rồi, mỗi loài hoa đều có một vẻ đẹp riêng con ạ. Con người cũng vậy, không phải ai cũng thành công chúa, nhưng điều đó không có gì đáng xấu hổ.<br>
        &emsp;Giét-xi đoán mẹ đã biết chuyện thay vai diễn của mình.<br>
        &emsp;Mẹ dịu dàng nói.<br>
        &emsp;- Con gái bé nhỏ của mẹ, con có giọng đọc truyền cảm, rất hợp với vai người dẫn chuyện. Nếu thiếu người dẫn chuyện, vở kịch cũng khó mà thành công được con ạ.<br>

				<div style='text-align: end'>(Du-nan biên soạn, Hòa Vân dịch)</div>
        </div>
      <div style="display:flex;">

               <div style='position: relative;padding-left:20px'>
               <div style='margin-top: 30px'>
              <div> <b style='color:rgb(151 30 17); '>3.</b>
               &ensp;Theo em, mẹ rủ Giét-xi cùng nhổ cỏ vườn để làm gì? Tìm câu trả lời đúng.<br>
                 <div style='width:17cm;margin-left:20px'>
                   <input id='0'  type='Circle' />
                 </div>

                 <div style=" position: absolute; top: 68px; left: 75px; width: max-content">
                        <div>
                        Mẹ muốn dạy cho Giét-xi biết cách làm cỏ vườn.<br>
                        Mẹ muốn Giét xi biết tên các loại hoa cỏ trong vườn.<br>
                        Mẹ muốn Giét-xi hiểu: Cũng như các loài hoa, mỗi người có vẻ đẹp và giá trị riêng.<br>
                        Mẹ muốn Giét-xi quên đi chuyện đóng kịch.
                        </div>
                  </div>
              </div>
              </div>
      </div>
			`,
    },
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p21_e4.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page21/Key/E4answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 200,
    stylesTextInput: {
      background: "none",
      borderBottom: "3px dotted",
      fontSize: 23,
      height: 29,
      marginBottom: -40,
      // textTransform: 'uppercase',
      // borderStyle: "dotted",
      textAlign: "center",
      fontWeight: "bold",
    },

    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src=""  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>CÔNG CHÚA VÀ NGƯỜI DẪN CHUYỆN</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `

    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>

    //     `,
    //   },
    // ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em hãy tìm từ phù hợp trong khung điền vào chỗ có nhiều dấu chấm để hoàn thành đoạn văn cho biết cảm giác của Giét-xi khi trò chuyện với mẹ. Em gõ chữ vào các chỗ trống.</span>
        <video src="Audios/fpt_ai/guide/p21_e4.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questions: [
      {
        title: `
        <img src='/img/FriendsPlus/Page20/E1/3.jpg' style='height:140mm;width:25cm' />
        <div style='width:25cm'>
        &emsp;Sau bữa ăn trưa, cô giáo thông báo Giét-xi được chọn đóng vai công chúa trong vở kịch sắp tới. Cảm nhận được
        ánh mắt ngưỡng mộ của bạn bè, Giét-xi vui lắm.<br>
        &emsp;Về nhà, Giét-xi hào hứng kể cho mẹ nghe. Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi. Giét-xi  chăm chỉ 
        luyện tập và nhớ lời thoại rất nhanh. Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết. 
        Cuối cùng, cô giáo đành nói:<br>
        &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch. Cô nghĩ vai đó hợp với em hơn. Em có đồng ý đổi vai không? <br>
        &emsp;Lời nói cô rất dịu dàng nhưng Giét-xi thấy buồn lắm. Sao không buồn khi phải nhường vai chính cho bạn!<br>
        &emsp;Thấy Giét-xi buồn, mẹ thủ thỉ:<br>
        &emsp;- Hôm nay mẹ con mình cùng nhau nhổ vườn cỏ nhé.<br>
        &emsp;Khu vườn vào xuân, những cây hồng leo khóa tấm áo xanh mới.<br>
        &emsp;- Mẹ con mình sẽ nhổ hết cỏ và hoa dại ở đây. Từ giờ vườn nhà ta chỉ có hoa hồng thôi. - Vừa nói, mẹ vừa chạm tay vào khóm bồ công anh.<br>
        &emsp;- Đừng, mẹ! Con thích hoa bồ công anh. Loài hoa nào cũng đẹp cả, kể cả bồ công anh. - Giét-xi nói.<br>
        &emsp;Mẹ mỉm cười:<br>
        &emsp;- Đúng rồi, mỗi loài hoa đều có một vẻ đẹp riêng con ạ. Con người cũng vậy, không phải ai cũng thành công chúa, nhưng điều đó không có gì đáng xấu hổ.<br>
        &emsp;Giét-xi đoán mẹ đã biết chuyện thay vai diễn của mình.<br>
        &emsp;Mẹ dịu dàng nói.<br>
        &emsp;- Con gái bé nhỏ của mẹ, con có giọng đọc truyền cảm, rất hợp với vai người dẫn chuyện. Nếu thiếu người dẫn chuyện, vở kịch cũng khó mà thành công được con ạ.<br>

				<div style='text-align: end'>(Du-nan biên soạn, Hòa Vân dịch)</div>
        </div>

        <div style='margin-top: 30px;'>
        <b style='color:rgb(151 30 17); '>4.</b>
        &ensp; Đoán xem Giét-xi cảm thấy thế nào khi trò chuyện cùng mẹ.<br><br>
        <div style='height: 2cm; padding: 20px; border: 3px solid rgb(251,99,64); border-radius: 10px; display: flex; justify-content: space-around; align-items: center; '>
        vai trò &ensp;&ensp; quan trọng &ensp;&ensp; riêng &ensp;&ensp; vẻ đẹp &ensp;&ensp; cảm thấy &ensp;&ensp; thể hiện &ensp;&ensp; thông báo &ensp;&ensp; buồn
        </div>

        <div style='margin-top: 30px; line-height: 46px'>
        Giét-xi hiểu vai công chúa và người dẫn chuyện trong vở kịch đều # như nhau, mỗi vai có một # riêng. Con người cũng như những loài hoa, mỗi người có một # và giá trị # . (Người đóng vai công chúa # lời nói, hành động của công chúa. Còn người đóng vai người dẫn chuyện có vai trò #  thông tin về thời gian, không gian, địa điểm, thậm chí cả về hoàn cảnh sống của nhân vật, kể về những gì đã xảy ra trong quá khứ hoặc ở bên ngoài sân khấu mà khán giả không trực tiếp nhìn thấy,…). Giét-xi sẽ #  không #  nữa. 
        </div>
        </div>
        
        `,
        answer: [
          "quan trọng",
          "vai trò",
          "vẻ đẹp",
          "riêng",
          "thể hiện",
          "thông báo",
          "cảm thấy",
          "buồn",
        ],
      },
    ],
  },
  5: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p21_e5.mp3",
    autoPlay: true,
    video: "",
    isTuLuan: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page21/Key/E5answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    textareaStyle: {
      // background: 'none',
      width: 900,
      fontSize: 23,
      // height: 70,
      paddingTop: 5,
    },

    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src=""  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>CÔNG CHÚA VÀ NGƯỜI DẪN CHUYỆN</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `

    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>

    //     `,
    //   },
    // ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em đọc kĩ bài đọc, suy nghĩ và gõ phần trả lời câu hỏi vào các dòng trống.</span>
        <div><video src="Audios/fpt_ai/guide/p21_e5.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questions: [
      {
        title: `
        <img src='/img/FriendsPlus/Page20/E1/3.jpg' style='height:140mm;width:25cm' />
        <div style='width:25cm'>
        &emsp;Sau bữa ăn trưa, cô giáo thông báo Giét-xi được chọn đóng vai công chúa trong vở kịch sắp tới. Cảm nhận được
        ánh mắt ngưỡng mộ của bạn bè, Giét-xi vui lắm.<br>
        &emsp;Về nhà, Giét-xi hào hứng kể cho mẹ nghe. Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi. Giét-xi  chăm chỉ 
        luyện tập và nhớ lời thoại rất nhanh. Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết. 
        Cuối cùng, cô giáo đành nói:<br>
        &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch. Cô nghĩ vai đó hợp với em hơn. Em có đồng ý đổi vai không? <br>
        &emsp;Lời nói cô rất dịu dàng nhưng Giét-xi thấy buồn lắm. Sao không buồn khi phải nhường vai chính cho bạn!<br>
        &emsp;Thấy Giét-xi buồn, mẹ thủ thỉ:<br>
        &emsp;- Hôm nay mẹ con mình cùng nhau nhổ vườn cỏ nhé.<br>
        &emsp;Khu vườn vào xuân, những cây hồng leo khóa tấm áo xanh mới.<br>
        &emsp;- Mẹ con mình sẽ nhổ hết cỏ và hoa dại ở đây. Từ giờ vườn nhà ta chỉ có hoa hồng thôi. - Vừa nói, mẹ vừa chạm tay vào khóm bồ công anh.<br>
        &emsp;- Đừng, mẹ! Con thích hoa bồ công anh. Loài hoa nào cũng đẹp cả, kể cả bồ công anh. - Giét-xi nói.<br>
        &emsp;Mẹ mỉm cười:<br>
        &emsp;- Đúng rồi, mỗi loài hoa đều có một vẻ đẹp riêng con ạ. Con người cũng vậy, không phải ai cũng thành công chúa, nhưng điều đó không có gì đáng xấu hổ.<br>
        &emsp;Giét-xi đoán mẹ đã biết chuyện thay vai diễn của mình.<br>
        &emsp;Mẹ dịu dàng nói.<br>
        &emsp;- Con gái bé nhỏ của mẹ, con có giọng đọc truyền cảm, rất hợp với vai người dẫn chuyện. Nếu thiếu người dẫn chuyện, vở kịch cũng khó mà thành công được con ạ.<br>

				<div style='text-align: end'>(Du-nan biên soạn, Hòa Vân dịch)</div>
        </div>

        <div style='margin-top: 30px;'>
        <b style='color:rgb(151 30 17); '>5.</b>
        &ensp; Em hiểu được điều gì từ câu chuyện trên?<br>
        <textarea id='0' rows='5'></textarea>
        </div>
        
        `,
        answer: [
          "",
          //"Đáp án tham khảo: Giét-xi buồn vì nghĩ rằng vai công chúa mới là vai chính, vai quan trọng; được đóng vai công chúa các bạn mới ngưỡng mộ vì công chúa rất xinh đẹp, còn vai người dẫn chuyện là vai phụ, không quan trọng,…",
        ],
      },
    ],
  },
  6: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P24-E1",
    audio: "Audios/fpt_ai/p21_e6.mp3",
    autoPlay: true,
    video: "",
    component: Circle_Write,
    exerciseKey: "img/FriendsPlus/Page21/Key/E6answerKey.png",
    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src=""  imageUrl="img/FriendsPlus/images/e.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>CÔNG CHÚA VÀ NGƯỜI DẪN CHUYỆN</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `

    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>

    //     `,
    //   },
    // ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em đọc kĩ bài đọc để tìm ra các danh từ chỉ người. Kích chuột để gạch chân các danh từ đó.</span>
        <div><video src="Audios/fpt_ai/guide/p21_e6.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 0,
          // borderColor: "transparent",
          // fontWeight: 600,
          // color: "rgb(88,147,198)",
        },
        // initialWordStyle: { fontWeight: 'bold', border: 'none', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: {
          padding: 0,
          borderBottom: "2px solid black",
          // borderRadius: "50%",
          // borderColor: "",
        },
        limitSelect: 30,
        listWordsStyle: {},
        listWords: [
          `&emsp;|Sau bữa ăn trưa, cô_giáo thông báo Giét-xi được chọn đóng vai công_chúa trong vở kịch sắp tới. Cảm nhận được
          ánh mắt ngưỡng mộ của bạn_bè, Giét-xi vui lắm|.<br>
          &emsp;|Về nhà, Giét-xi hào hứng kể cho mẹ nghe|. Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi|. Giét-xi  chăm chỉ 
          luyện tập và nhớ lời thoại rất nhanh|. Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết|. 
          Cuối cùng, cô_giáo đành nói:<br>
          &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch|. Cô nghĩ vai đó hợp với em hơn|. Em có đồng ý đổi vai không? <br>
          &emsp;|Lời nói cô rất dịu dàng nhưng Giét-xi thấy buồn lắm|. Sao không buồn khi phải nhường vai chính cho bạn!<br>
          &emsp;Thấy Giét-xi buồn, mẹ thủ thỉ:<br>
          &emsp;- Hôm nay mẹ con mình cùng nhau nhổ vườn cỏ nhé|.<br>
          &emsp;Khu vườn vào xuân, những cây hồng leo khóa tấm áo xanh mới|.<br>
          &emsp;- Mẹ con mình sẽ nhổ hết cỏ và hoa dại ở đây|. Từ giờ vườn nhà ta chỉ có hoa hồng thôi|. - Vừa nói, mẹ vừa chạm tay vào khóm bồ công anh|.<br>
          &emsp;- Đừng, mẹ! Con thích hoa bồ công anh|. Loài hoa nào cũng đẹp cả, kể cả bồ công anh|. - Giét-xi nói|.<br>
          &emsp;|Mẹ mỉm cười:<br>
          &emsp;- Đúng rồi, mỗi loài hoa đều có một vẻ đẹp riêng con ạ|. Con người cũng vậy, không phải ai cũng thành công_chúa|, nhưng điều đó không có gì đáng xấu hổ|.<br>
          &emsp;|Giét-xi đoán mẹ đã biết chuyện thay vai diễn của mình|.<br>
          &emsp;|Mẹ dịu dàng nói|.<br>
          &emsp;- Con gái bé nhỏ của mẹ, con có giọng đọc truyền cảm, rất hợp với vai người_dẫn_chuyện|. Nếu thiếu người_dẫn_chuyện, vở kịch cũng khó mà thành công được con ạ|.<br>`,
        ],
        answers: [
          "0-10",
          "0-16",
          "0-26",
          "0-74",
          "0-76",
          "0-110",
          "0-120",
          "0-136",
          "0-148",
          "0-152",
          "0-224",
          "0-264",
          "0-292",
          "0-388",
          "0-440",
          "0-476",
          "0-566",
          "0-620",
          "0-664",
          "0-734",
          "0-808",
          "0-854",
          "0-900",
          "0-858",
          "0-972",
          "0-964",
          "0-942",
          "0-706",
        ],
        initialValue: [],
      },
      Layout: `
      <img src='/img/FriendsPlus/Page20/E1/3.jpg' style='height:140mm;width:25cm' /><br><br>
      <div style='width:25cm'>
          <b style='color:rgb(151 30 17); margin-top: 10px'>1.</b>
          &ensp; Tìm các danh từ chỉ người trong bài đọc <i>Công chúa và người dẫn chuyện</i>.<br><br>
          <input id='0'  type='Circle' />
      </div>
      
			`,
    },
  },
  7: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p21_e7.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page21/Key/E7answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    textareaStyle: {
      // background: 'none',
      width: 900,
      fontSize: 23,
      // height: 70,
      paddingTop: 5,
    },
    isTuLuan: true,

    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src=""  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-style:italic;font-weight:bold;color:#5d4c80'>CÔNG CHÚA VÀ NGƯỜI DẪN CHUYỆN</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `

    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>

    //     `,
    //   },
    // ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>
        – Nhân vật em yêu thích là ai?<br>
        – Nhân vật đó như thế nào?<br>
        Gõ nội dung phần trả lời của em vào các dòng trống.
        </span>
        <div><video src="Audios/fpt_ai/guide/p21_e7.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questions: [
      {
        title: `
        <img src='/img/FriendsPlus/Page20/E1/3.jpg' style='height:140mm;width:25cm' />
        <div style='width:25cm'>
        &emsp;Sau bữa ăn trưa, cô giáo thông báo Giét-xi được chọn đóng vai công chúa trong vở kịch sắp tới. Cảm nhận được
        ánh mắt ngưỡng mộ của bạn bè, Giét-xi vui lắm.<br>
        &emsp;Về nhà, Giét-xi hào hứng kể cho mẹ nghe. Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi. Giét-xi  chăm chỉ 
        luyện tập và nhớ lời thoại rất nhanh. Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết. 
        Cuối cùng, cô giáo đành nói:<br>
        &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch. Cô nghĩ vai đó hợp với em hơn. Em có đồng ý đổi vai không? <br>
        &emsp;Lời nói cô rất dịu dàng nhưng Giét-xi thấy buồn lắm. Sao không buồn khi phải nhường vai chính cho bạn!<br>
        &emsp;Thấy Giét-xi buồn, mẹ thủ thỉ:<br>
        &emsp;- Hôm nay mẹ con mình cùng nhau nhổ vườn cỏ nhé.<br>
        &emsp;Khu vườn vào xuân, những cây hồng leo khóa tấm áo xanh mới.<br>
        &emsp;- Mẹ con mình sẽ nhổ hết cỏ và hoa dại ở đây. Từ giờ vườn nhà ta chỉ có hoa hồng thôi. - Vừa nói, mẹ vừa chạm tay vào khóm bồ công anh.<br>
        &emsp;- Đừng, mẹ! Con thích hoa bồ công anh. Loài hoa nào cũng đẹp cả, kể cả bồ công anh. - Giét-xi nói.<br>
        &emsp;Mẹ mỉm cười:<br>
        &emsp;- Đúng rồi, mỗi loài hoa đều có một vẻ đẹp riêng con ạ. Con người cũng vậy, không phải ai cũng thành công chúa, nhưng điều đó không có gì đáng xấu hổ.<br>
        &emsp;Giét-xi đoán mẹ đã biết chuyện thay vai diễn của mình.<br>
        &emsp;Mẹ dịu dàng nói.<br>
        &emsp;- Con gái bé nhỏ của mẹ, con có giọng đọc truyền cảm, rất hợp với vai người dẫn chuyện. Nếu thiếu người dẫn chuyện, vở kịch cũng khó mà thành công được con ạ.<br>

				<div style='text-align: end'>(Du-nan biên soạn, Hòa Vân dịch)</div>
        </div>

        <div style='margin-top: 30px;'>
        <b style='color:rgb(151 30 17); '>2.</b>
        &ensp; Viết 2 – 3 câu nêu nhận xét về một nhân vật em yêu thích trong câu chuyện trên.<br>
        <textarea id='0' rows='5'></textarea>
        </div>
        
        `,
        answer: [
          "",
          //"Đáp án tham khảo: Giét-xi buồn vì nghĩ rằng vai công chúa mới là vai chính, vai quan trọng; được đóng vai công chúa các bạn mới ngưỡng mộ vì công chúa rất xinh đẹp, còn vai người dẫn chuyện là vai phụ, không quan trọng,…",
        ],
      },
    ],
  },
  8: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p21_e8.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page21/Key/E8answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    textareaStyle: {
      // background: 'none',
      width: 900,
      fontSize: 23,
      // height: 70,
      paddingTop: 5,
    },
    isTuLuan: true,
    titleQuestion: [
      {
        num: "",
        title: `
        <span style='text-align:center;font-weight:bold;color:#5d4c80; margin-left: 200px'>VIẾT ĐOẠN VĂN NÊU Ý KIẾN</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `

    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>

    //     `,
    //   },
    // ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>
        Em dựa vào các ý đã tìm được ở ba phần: mở đầu, triển khai, kết thúc để viết đoạn văn nêu lí do yêu thích một câu chuyện đã đọc hoặc đã nghe.<br> Gõ đoạn văn vào các dòng trống.
        </span>
        <div><video src="Audios/fpt_ai/guide/p21_e8.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questions: [
      {
        title: `
        <div style='width:20cm;border: 5px solid rgb(29,193,215);padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
        <b>Đề bài: </b>Viết đoạn văn nêu lí do yêu thích một câu chuyện đã đọc hoặc đã nghe.
      </div>   
    <div style='width:20cm;margin:20px 0px'>
      <div>
        <b style='color:rgb(3, 103, 181)'>1.</b>&ensp;Dựa vào các ý đã tìm trong hoạt động Viết ở Bài 3, viết đoạn văn nêu lí do yêu thích một câu chuyện đã đọc hoặc đã nghe.<br>
        <b><i>Lưu ý:</i></b><br>
– Chọn cách giới thiệu câu chuyện gây được chú ý và nêu nhận xét, đánh giá chung về câu chuyện.<br>
– Trình bày rõ các lí do yêu thích câu chuyện và đưa dẫn chứng minh hoạ.<br>
– Các câu trong đoạn văn được viết liên tục, không xuống dòng.<br>

      </div>
      <div style=''>
        <textarea id='0' rows='8'></textarea>
      </div>
        
        `,
        answer: [
          "",
          //"Đáp án tham khảo: Giét-xi buồn vì nghĩ rằng vai công chúa mới là vai chính, vai quan trọng; được đóng vai công chúa các bạn mới ngưỡng mộ vì công chúa rất xinh đẹp, còn vai người dẫn chuyện là vai phụ, không quan trọng,…",
        ],
      },
    ],
  },
};

export default json;
